// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c30fd607","619":"f842fcef"}[chunkId] + ".chunk.js";
};